import { useEffect, useRef } from 'react'

import { useGetIntermediateLoginTokenMutation } from 'shared/api/auth/requests'
import { useExternalLoginStore } from 'shared/stores/externalLoginStore'

import { useSearchParams } from './useSearchParams'
import { useUserContext } from './useUserContext'

export const useExternalLogin = () => {
  const { externalRedirect, setExternalRedirect, isExternal } =
    useExternalLoginStore()
  const { user } = useUserContext()
  const [{ redirect }] = useSearchParams<{ redirect?: string }>()
  const isRedirecting = useRef(false)

  useEffect(() => {
    if (redirect) {
      setExternalRedirect(redirect)
    }
  }, [redirect, setExternalRedirect])

  const getIntermediateLoginTokenMutation =
    useGetIntermediateLoginTokenMutation({
      onSuccess: data => {
        if (!externalRedirect) return
        const url = new URL(externalRedirect)
        url.searchParams.set('token', data.intermediate_login_token)
        window.location.href = url.toString()
      }
    })

  useEffect(() => {
    if (
      isExternal &&
      externalRedirect &&
      user?.email &&
      getIntermediateLoginTokenMutation.isIdle &&
      !isRedirecting.current
    ) {
      isRedirecting.current = true
      getIntermediateLoginTokenMutation.mutate({ email: user.email })
    }
  }, [isExternal, externalRedirect, user, getIntermediateLoginTokenMutation])

  return externalRedirect
}
